import { BaseSupportFeatureRequestModel } from "api/baseSupportFeatureModel/BaseSupportFeatureRequestModel";
import { TypeOfSupportEnum } from "utils/enums/TypeOfSupportEnum";

export class ApiDocumentRequestModel extends BaseSupportFeatureRequestModel {
  typeOfSupport?: TypeOfSupportEnum;
  service?: string;

  constructor(data?: { typeOfSupport?: TypeOfSupportEnum; service: string }) {
    super();
    this.typeOfSupport = data?.typeOfSupport;
    this.service = data?.service;
  }
}
